import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Turns an axios error from the backend into a string that is safe to show in a
// toast. FastAPI returns `detail` as a string for HTTPException, but as an array
// of {loc, msg, ...} objects for a 422 validation error. Passing that array
// straight to toast.error() crashes React ("Objects are not valid as a React
// child"), so use the first message instead, without pydantic's "Value error, "
// prefix, and led by the field name from `loc` ("Last name must be ...").
export function apiErrorMessage(err, fallback) {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  const first = Array.isArray(detail) ? detail[0] : null;
  if (typeof first?.msg !== "string") return fallback;
  const msg = first.msg.replace(/^Value error, /, "");
  // Only fragments ("must be ...") need the field name. Messages that are already
  // sentences ("Password is too common ...") are shown as they are.
  const field = Array.isArray(first.loc) ? first.loc[first.loc.length - 1] : null;
  if (typeof field !== "string" || /^[A-Z]/.test(msg)) return msg;
  const label = field.replace(/_/g, " ");
  return `${label.charAt(0).toUpperCase()}${label.slice(1)} ${msg}`;
}
